/**
 * @module Toast Component
 */
import React, { PropTypes, PureComponent } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styles from './styles.scss';
import messages from './i18n';
import { Close, NoInternet } from '../../shared';


/**
 * @type {PureComponent} Toast PureComponent
 */
export class Toast extends PureComponent {
  // /**
  //  * executes post mount
  //  */
  // componentDidMount() { // could be used if need to add timeouts
  //   const { signUpDelToast } = this.props;
  //   this.timer = setTimeout(signUpDelToast, 10000);
  // }


  // /**
  //  * executes pre unmount
  //  */
  // componentWillUnmount() {
  //   clearTimeout(this.timer);
  // }

  /**
   * executes on render
   */
  render() {
    const { signUpDelToast } = this.props;

    return (
      <div className={styles.toast} onClick={signUpDelToast}>
        <div
          className={styles.view}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div className={styles.image}>
            <NoInternet
              className={styles.NoInternetIcon}
            />
          </div>
          <div className={styles.message}>
            <div className={styles.heading}>
              <FormattedMessage {...messages.NoInternetHeading} />
            </div>
            <div className={styles.body}>
              <FormattedMessage {...messages.NoInternetBody} />
            </div>
          </div>
          <div className={styles.close} onClick={signUpDelToast}>
            <Close
              className={styles.closeIcon}
            />
          </div>
        </div>
      </div>
    );
  }
}


/**
 * Toast propTypes
 */
Toast.propTypes = {
  signUp: PropTypes.object,
  signUpDelToast: PropTypes.func,
};


/**
 * default export
 */
export default injectIntl(Toast);



// WEBPACK FOOTER //
// ./src/components/sign_up/shared/toast/index.jsx